module.exports = __webpack_public_path__ + "img/ensuring-fairness.0acb90f0.png";